import React from 'react'
import './style.less'
import emptyImg from "../../img/empty.png"

function EmptyBox(props) {

    const {text = '暂无数据'} = props

    return (
        <div className="Empty-box">
            <div className="img-div">
                <img src={emptyImg} alt=""/>
            </div>
            <div className="empty-font">{text}</div>
        </div>
    );
}

export default EmptyBox
